import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useContext, useMemo } from 'react';
import { getEnterpriseRoute } from 'utils';

export default function useUserEnterpriseRoute() {
  const { isRWCMember, isOfficeManager, isEnterpriseHead, enterprise } =
    useContext(CurrentUserContext);

  return useMemo(
    () =>
      isOfficeManager || isEnterpriseHead
        ? getEnterpriseRoute(
            isRWCMember,
            enterprise?.isDemo,
            enterprise?._id,
            isOfficeManager ? 'team' : 'analytics',
          )
        : '',
    [
      enterprise?._id,
      enterprise?.isDemo,
      isEnterpriseHead,
      isOfficeManager,
      isRWCMember,
    ],
  );
}
